/**
 * Opens the global search (Ctrl/⌘ K) from a page. The search lives in the app
 * shell; a page that wants to offer it (the 404) sends this event rather than
 * reaching into the shell's state.
 */
export const OPEN_GLOBAL_SEARCH = 'grow:open-global-search';

export function openGlobalSearch() {
  window.dispatchEvent(new Event(OPEN_GLOBAL_SEARCH));
}
